import type {
  DeploymentRequestResourceOptionBffV2Api,
  DeploymentRequestResourceOptionMinimalV2Api,
  DeploymentRequestResourceOptionV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { AdvancedSearchInput, AdvancedSearchOperatorsValues } from '@ingenico/react-ui/advanced-search';
import { isEmpty, toArray, toString } from 'lodash-es';
import type { TargetDeploymentInfoScope } from '../../../components/target-deployment-info/TargetDeploymentInfo.ctrl';
import type { DMSearchRequest } from '../../models/common.model';
import type { DeploymentRequestResource } from '../../models/deployment/deploymentById.model';

export function computeType(
  options:
    | DeploymentRequestResourceOptionBffV2Api
    | DeploymentRequestResourceOptionMinimalV2Api
    | DeploymentRequestResourceOptionV2Api,
): string {
  const hasConfiguration = options.configuration && !isEmpty(options.configuration);
  const hasDelete = options.delete && !isEmpty(options.delete);

  if (hasDelete && hasConfiguration) {
    return 'type.both';
  }
  if (hasDelete) {
    return 'type.delete';
  }
  if (hasConfiguration) {
    return 'type.configuration';
  }
  return '';
}

export function computeConfigurationProfile(
  options:
    | DeploymentRequestResourceOptionBffV2Api
    | DeploymentRequestResourceOptionMinimalV2Api
    | DeploymentRequestResourceOptionV2Api,
): string {
  const reference = options?.configuration?.reference;
  const name = reference && 'name' in reference ? (reference as { name: string }).name : undefined;
  return toString(name ?? 'configuration.empty');
}

export function convertSearchRequestToAdvancedSearchInput(query?: DMSearchRequest): AdvancedSearchInput[] {
  return toArray(
    query?.filters.map((filter) => ({
      condition: filter.operator as unknown as AdvancedSearchOperatorsValues,
      criteria: filter.value,
      field: filter.name,
    })),
  );
}

export function getDeploymentScope(
  dynamicGroups?: AdvancedSearchInput[] | null,
  deploymentRequestResource?: DeploymentRequestResource | null,
): TargetDeploymentInfoScope | undefined {
  return dynamicGroups || deploymentRequestResource?.dynamicGroup
    ? {
        dynamicGroupName: deploymentRequestResource?.dynamicGroup?.reference?.name,
        advancedFilters: convertSearchRequestToAdvancedSearchInput(deploymentRequestResource?.dynamicGroup?.query),
        dynamicGroupCriteria: dynamicGroups ?? undefined,
      }
    : undefined;
}
